import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import * as globals from '../globals';

@Injectable()
export class RegisterService {
  private url = globals.APIURL + '/register';
  private apurl = this.url + '/apregister';
  constructor(private http: Http) { }
  register(registrationUser): Observable<string> {
    console.log('Registration service method called');
    // Got to do this because we don't want to send password anymore
    let body = JSON.stringify({
      email: registrationUser.email, firstname: registrationUser.firstname,
      lastname: registrationUser.lastname, phone: registrationUser.phone,
      company: registrationUser.company, addinfo: registrationUser.addinfo
    });
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    console.log('Login: URL =>', this.url);
    console.log('Login: BODY =>', body);
    console.log('Login: OPTIONS =>', options);
    return this.http.post(this.url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  autopilotregister(registrationUser): Observable<string> {
    console.log('Registration service method called');
    // Got to do this because we don't want to send password anymore
    let body = JSON.stringify({
      email: registrationUser.email, firstname: registrationUser.firstname,
      lastname: registrationUser.lastname, phone: registrationUser.phone,
      company: registrationUser.company, addinfo: registrationUser.addinfo
    });
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    console.log('Login: URL =>', this.apurl);
    console.log('Login: BODY =>', body);
    console.log('Login: OPTIONS =>', options);
    return this.http.post(this.apurl, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  private extractData(res: Response) {
    let body = res.json();
    console.log('BODY:', body);
    return body || {};
  }

  handleError(error: any) {
    // In a real world app, we might use a remote logging infrastructure
    // We'd also dig deeper into the error to get a better message
    let errMsg = (error.message) ? error.message :
      error.status ? `${error.status} - ${error.statusText}` : 'Server error';
    console.error('CAUGHT AN ERROR:', errMsg); // log to console instead
    return Observable.throw(errMsg);
  }
}



// WEBPACK FOOTER //
// /Users/mark/Documents/Source/MachineResearch/MR2/angular2/src/app/register/register.service.ts